module.exports = __webpack_public_path__ + "img/oracle.a98bcffe.svg";